/**
 * Pure logic helpers for Spec 003 — §35a per-document subtotal row.
 *
 * These functions are consumed by HandwerkerReportTable.svelte to render
 * the per-document <tfoot> subtotal in the expanded line-item sub-table.
 */

export interface HandwerkerEntryData {
  extractionFailed?: boolean;
  lineItems?: unknown[];
  totalDeductibleBrutto?: unknown;
}

/**
 * Returns true iff the per-document subtotal row should be rendered.
 * Returns false when extractionFailed is true OR lineItems is empty/absent.
 */
export function shouldShowSubtotal(data: HandwerkerEntryData): boolean {
  if (data.extractionFailed === true) {
    return false;
  }
  const items = data.lineItems;
  if (!Array.isArray(items) || items.length === 0) {
    return false;
  }
  return true;
}

/**
 * Returns the numeric subtotal value for the document.
 * Equivalent to Number(data.totalDeductibleBrutto), returning 0 for missing/NaN.
 */
export function getSubtotalAmount(data: HandwerkerEntryData): number {
  const num = Number(data.totalDeductibleBrutto);
  if (isNaN(num)) {
    return 0;
  }
  return num;
}

/**
 * Formats amount as EUR currency string using Intl.NumberFormat.
 * locale — BCP-47 locale string, e.g. "de-DE" or "en-US".
 */
export function formatSubtotalAmount(amount: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}
